import { render, staticRenderFns } from "./yuyuerili.vue?vue&type=template&id=51073918&scoped=true"
import script from "./yuyuerili.vue?vue&type=script&lang=js"
export * from "./yuyuerili.vue?vue&type=script&lang=js"
import style0 from "./yuyuerili.vue?vue&type=style&index=0&id=51073918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51073918",
  null
  
)

export default component.exports